import { render, staticRenderFns } from "./addPrice.vue?vue&type=template&id=8ad8e506&scoped=true"
import script from "./addPrice.vue?vue&type=script&lang=js"
export * from "./addPrice.vue?vue&type=script&lang=js"
import style0 from "./addPrice.vue?vue&type=style&index=0&id=8ad8e506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad8e506",
  null
  
)

export default component.exports